import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { withTheme } from '@material-ui/core/styles';
import Installation from './Installation';
import PageCommon from '../../Common';
import PageNavBar from '../../NavBar/NavBar';

var InstallationPage = function InstallationPage(_ref) {
  var theme = _ref.theme,
      location = _ref.location,
      resetPath = _ref.resetPath,
      rest = _objectWithoutProperties(_ref, ["theme", "location", "resetPath"]);

  var bgColor = theme.common.Page.NavBar.style.backgroundColor;
  var reset = location.pathname.startsWith(resetPath);
  return React.createElement(React.Fragment, null, React.createElement(PageNavBar, null), React.createElement(PageCommon, {
    style: {
      color: theme.palette.getContrastText(bgColor),
      backgroundColor: bgColor
    }
  }, React.createElement(Installation, Object.assign({}, rest, {
    showResetToDefault: reset
  }))));
};

export default withTheme(InstallationPage);